<template>
  <div style="background: #ff0000">
    <h1 style="color: #fff">{{ message }}</h1>
  </div>
</template>

<script setup>
const message = 'This component has been deprecated. Please use the Main Header component instead.';
</script>
